/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleFilterRequest } from './RoleFilterRequest';
import {
    RoleFilterRequestFromJSON,
    RoleFilterRequestFromJSONTyped,
    RoleFilterRequestToJSON,
    RoleFilterRequestToJSONTyped,
} from './RoleFilterRequest';
import type { PermissionFilterRequest } from './PermissionFilterRequest';
import {
    PermissionFilterRequestFromJSON,
    PermissionFilterRequestFromJSONTyped,
    PermissionFilterRequestToJSON,
    PermissionFilterRequestToJSONTyped,
} from './PermissionFilterRequest';
import type { ApplicationFilterRequest } from './ApplicationFilterRequest';
import {
    ApplicationFilterRequestFromJSON,
    ApplicationFilterRequestFromJSONTyped,
    ApplicationFilterRequestToJSON,
    ApplicationFilterRequestToJSONTyped,
} from './ApplicationFilterRequest';
import type { ExternalUserSearchOrderByPaginationQuery } from './ExternalUserSearchOrderByPaginationQuery';
import {
    ExternalUserSearchOrderByPaginationQueryFromJSON,
    ExternalUserSearchOrderByPaginationQueryFromJSONTyped,
    ExternalUserSearchOrderByPaginationQueryToJSON,
    ExternalUserSearchOrderByPaginationQueryToJSONTyped,
} from './ExternalUserSearchOrderByPaginationQuery';
import type { ExternalUserStatus } from './ExternalUserStatus';
import {
    ExternalUserStatusFromJSON,
    ExternalUserStatusFromJSONTyped,
    ExternalUserStatusToJSON,
    ExternalUserStatusToJSONTyped,
} from './ExternalUserStatus';

/**
 * 
 * @export
 * @interface ExternalUserSearchRequest
 */
export interface ExternalUserSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof ExternalUserSearchRequest
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserSearchRequest
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserSearchRequest
     */
    organizationName?: string | null;
    /**
     * 
     * @type {ExternalUserSearchOrderByPaginationQuery}
     * @memberof ExternalUserSearchRequest
     */
    paginationQuery?: ExternalUserSearchOrderByPaginationQuery;
    /**
     * 
     * @type {Array<any>}
     * @memberof ExternalUserSearchRequest
     */
    organizationGroupIds?: Array<any> | null;
    /**
     * 
     * @type {Array<ExternalUserStatus>}
     * @memberof ExternalUserSearchRequest
     */
    statusFilter?: Array<ExternalUserStatus> | null;
    /**
     * 
     * @type {RoleFilterRequest}
     * @memberof ExternalUserSearchRequest
     */
    roleFilter?: RoleFilterRequest;
    /**
     * 
     * @type {PermissionFilterRequest}
     * @memberof ExternalUserSearchRequest
     */
    permissionFilter?: PermissionFilterRequest;
    /**
     * 
     * @type {ApplicationFilterRequest}
     * @memberof ExternalUserSearchRequest
     */
    applicationFilter?: ApplicationFilterRequest;
}

/**
 * Check if a given object implements the ExternalUserSearchRequest interface.
 */
export function instanceOfExternalUserSearchRequest(value: object): value is ExternalUserSearchRequest {
    return true;
}

export function ExternalUserSearchRequestFromJSON(json: any): ExternalUserSearchRequest {
    return ExternalUserSearchRequestFromJSONTyped(json, false);
}

export function ExternalUserSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstname': json['firstname'] === undefined ? undefined : json['firstname'] === null ? null : json['firstname'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'organizationName': json['organizationName'] === undefined ? undefined : json['organizationName'] === null ? null : json['organizationName'],
        'paginationQuery': json['paginationQuery'] == null ? undefined : ExternalUserSearchOrderByPaginationQueryFromJSON(json['paginationQuery']),
        'organizationGroupIds': json['organizationGroupIds'] === undefined ? undefined : json['organizationGroupIds'] === null ? null : json['organizationGroupIds'],
        'statusFilter': json['statusFilter'] === undefined ? undefined : json['statusFilter'] === null ? null : ((json['statusFilter'] as Array<any>).map(ExternalUserStatusFromJSON)),
        'roleFilter': json['roleFilter'] == null ? undefined : RoleFilterRequestFromJSON(json['roleFilter']),
        'permissionFilter': json['permissionFilter'] == null ? undefined : PermissionFilterRequestFromJSON(json['permissionFilter']),
        'applicationFilter': json['applicationFilter'] == null ? undefined : ApplicationFilterRequestFromJSON(json['applicationFilter']),
    };
}

export function ExternalUserSearchRequestToJSON(json: any): ExternalUserSearchRequest {
    return ExternalUserSearchRequestToJSONTyped(json, false);
}

export function ExternalUserSearchRequestToJSONTyped(value?: ExternalUserSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstname': value['firstname'],
        'surname': value['surname'],
        'organizationName': value['organizationName'],
        'paginationQuery': ExternalUserSearchOrderByPaginationQueryToJSON(value['paginationQuery']),
        'organizationGroupIds': value['organizationGroupIds'],
        'statusFilter': value['statusFilter'] == null ? undefined : ((value['statusFilter'] as Array<any>).map(ExternalUserStatusToJSON)),
        'roleFilter': RoleFilterRequestToJSON(value['roleFilter']),
        'permissionFilter': PermissionFilterRequestToJSON(value['permissionFilter']),
        'applicationFilter': ApplicationFilterRequestToJSON(value['applicationFilter']),
    };
}

